<!-- ===== HERO ===== -->
<section class="hero">
  
  <div class="container narrow">
    <h1 class="hero__title">
      <span class="hero__top">Analizadores Hematológicos</span>

      <span class="hero__line">
        <span class="type t1" style="--nch:22;">Alphatec Scientific®</span>
        <span class="type t2" style="--nch:20;">Resultados Precisos.</span>
      </span>
    </h1>
  </div>

  <br>

<!-- HERO: Video con overlay + texto + CTAs -->
<div class="hero-video">
  <video class="hero-video__media"
         src="assets/videos/alphatec-hero.mp4"
         poster="assets/videos/alphatec-hero.png"
         autoplay muted loop playsinline preload="metadata"
         controlslist="nodownload noplaybackrate nofullscreen"
         disablepictureinpicture>
    Tu navegador no soporta video embebido.
  </video>

  <!-- Capa oscura -->
  <div class="hero-video__overlay" aria-hidden="true"></div>

  <!-- Contenido sobre el video -->
  <div class="hero-cta" role="group" aria-label="Acciones principales">
    <p class="hero-cta__lead">
      Combina analizadores, reactivos y software médico de última generación
    </p>

    <div class="hero-cta__buttons">
      <a class="btn btn-xl btn-pro-glass" routerLink="/tienda">Explorar productos</a>
      <a class="btn btn-xl btn-ghost-orange" routerLink="/contacto">Cotiza ahora</a>
    </div>
  </div>
</div>




  
</section>

<br><br>
<!-- ===== Nuestras categorías ===== -->
<section class="cats">
  <div class="container">
    <header class="cats__head">
      <h2 style="font-weight: 400; color: #EE3221;">Explora nuestras líneas</h2>
      <p class="sub">
        Explora nuestras líneas de diagnóstico y soluciones de laboratorio. 
      </p>
    </header>

    <div id="catCarousel"
         class="carousel slide cats__carousel"
         data-bs-ride="carousel"
         data-bs-interval="5200"
         data-bs-pause="hover">

      <!-- Indicadores -->
      <div class="carousel-indicators">
        <button *ngFor="let s of categorySlides; let i = index"
                type="button"
                data-bs-target="#catCarousel"
                [attr.data-bs-slide-to]="i"
                [class.active]="i===0"
                [attr.aria-current]="i===0 ? 'true' : null"
                [attr.aria-label]="'Slide ' + (i+1)"></button>
      </div>

      <!-- Slides -->
      <div class="carousel-inner">
        <div class="carousel-item" *ngFor="let slide of categorySlides; let si = index" [class.active]="si===0">
          <div class="cats-grid">
            <a class="cat-item"
               *ngFor="let c of slide; trackBy: trackByCategory"
               [routerLink]="['/categoria', c.slug]"
               [attr.aria-label]="c.name">
              <figure class="cat-item__figure">
                <img [src]="'assets/categories/' + c.file" [alt]="c.name" loading="lazy">
              </figure>
              <span class="cat-item__name">{{ c.name }}</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Controles -->
      <button class="carousel-control-prev" type="button" data-bs-target="#catCarousel" data-bs-slide="prev" aria-label="Anterior">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#catCarousel" data-bs-slide="next" aria-label="Siguiente">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
      </button>
    </div>

    <!-- CTAs -->
    <div class="cats__cta">
      <a class="btn btn-pro" routerLink="/tienda">Ver categorías</a>
      <a class="btn btn-glass-blue" routerLink="/contacto">Solicitar cotización</a>
    </div>
  </div>
</section>


<!-- ===== Sobre nosotros ===== -->
<section class="about">
  <div class="container">
    <div class="about_head">
      <div style="margin-bottom: 10px;">
      </div>
      <h2>  <img src="assets/logo/icon_alp.png" width="70px"> Alphatec Scientific®</h2>
      <p class="accent-2" style="color: #41d18e; font-size: 12px; "> TECHNOLOGY CARE  </p>
    </div>
    <div class="connect__grid">
 <figure class="series__media_card">
        <video
          class="series__media_card__media"
          src="assets/videos/vid_01.mp4"
          autoplay
          muted
          loop
          playsinline
          preload="metadata"
          controlslist="nodownload noplaybackrate nofullscreen"
          disablepictureinpicture>
        </video>
      </figure>

      <div class="connect__content">
        <ul class="bullets">
          <img src="assets/logo/alphatec_name.png" width="85px"> Proporciona soluciones de diagnóstico in vitro,
            tecnologías de información médica y equipos hospitalarios
             para la mejora de la atención médica. El Centro de Operaciones,
              ubicado en Perú, busca innovar y desarrollar productos médicos 
              para la población mundial. <br><br> Centrados en el diagnóstico y el 
              tratamiento óptimo,  <img src="assets/logo/alphatec_name.png" width="85px">   ofrecemos productos de la más alta calidad, basados 
              ​​en las normas ISO 9001, ISO 13485, CE y Marca Perú, para las diversas necesidades 
              de laboratorios médicos y equipos hospitalarios, así como una amplia gama 
              de productos para su satisfacción y confianza.
        </ul>

        <div class="cta pt-4"> 
          <a routerLink="/nostros"  href="/nosotros" class="btn btn-pro">Mas información</a>
          <a   [routerLink]="['/contacto']" routerLinkActive="router-link-active"   class="btn btn-pro-outline">Contáctanos</a>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- ===== Serie M (bloque oscuro) ===== -->
<section class="series">
  <div class="container">
    <h2 style="font-weight: 500;">
      Conoce los analizadores <span class="accent-2">Serie M</span><br>
      Alphatec Scientific®.<br>
      <small style="color:#EE3221; font-weight:lighter;">Creados para crecer.</small>
    </h2>
    <br>

    <!-- === Carrusel Serie M === -->
    <div id="seriesCarousel"
         class="carousel slide series__carousel"
         data-bs-ride="carousel"
         data-bs-touch="true"
         data-bs-interval="4500"
         data-bs-pause="false">

      <!-- Indicadores (puntos) -->
      <div class="carousel-indicators">
        <button *ngFor="let s of serieMSlides; let i = index"
                type="button"
                data-bs-target="#seriesCarousel"
                [attr.data-bs-slide-to]="i"
                [class.active]="i === 0"
                [attr.aria-current]="i === 0 ? 'true' : null"
                [attr.aria-label]="'Slide ' + (i+1)"></button>
      </div>

      <!-- Slides -->
      <div class="carousel-inner">
        <div class="carousel-item" *ngFor="let s of serieMSlides; let i = index" [class.active]="i === 0"
             data-bs-interval="4500">
          <img [src]="s.src" [alt]="s.alt" loading="lazy" class="d-block w-100">
        </div>
      </div>

      <!-- Controles -->
      <button class="carousel-control-prev" type="button" data-bs-target="#seriesCarousel" data-bs-slide="prev" aria-label="Anterior">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#seriesCarousel" data-bs-slide="next" aria-label="Siguiente">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
      </button>
    </div>
    <!-- === /Carrusel Serie M === -->

    <div class="cats__cta">
      <a class="btn btn-pro" routerLink="/tienda" href="/categoria/chemistry">Ver Bioquímicos</a>
      <a class="btn btn-glass-blue" routerLink="/cotizar">Solicitar cotización</a>
    </div>

  </div>
</section>


<!-- ===== Bioquímicos ===== -->
<section class="biochem">
  <div class="container">
    <h2>Analizadores Bioquímicos <br> Alphatec Scientific®.</h2>
    <p class="subtitle">Más analitos, menos pasos, <br> <span class="accent">mejores decisiones</span>.</p>

   <div class="cards">
  <!-- Card 1 con VIDEO -->
  <article class="card-i">
    <figure class="series__media_card">
      <video
        class="series__media_card__media"
        src="assets/videos/vid_02.mp4"
        autoplay
        muted
        loop
        playsinline
        preload="metadata"
        controlslist="nodownload noplaybackrate nofullscreen"
        disablepictureinpicture>
      </video>
    </figure>

    <div class="card-i__body">
      <h3>ALPSC® 200</h3>
      <p>Analizador de química clínica automático para rutinas diarias.</p>
    </div>
  </article>

    <!-- Card 2 con VIDEO -->
    <article class="card-i">
      <figure class="series__media_card">
        <video
          class="series__media_card__media"
          src="assets/videos/vid_01.mp4"
          autoplay
          muted
          loop
          playsinline
          preload="metadata"
          controlslist="nodownload noplaybackrate nofullscreen"
          disablepictureinpicture>
        </video>
      </figure>

      <div class="card-i__body">
        <h3>ALPSC® 800</h3>
        <p>Alta capacidad, precisión y conectividad para laboratorios en crecimiento.</p>
      </div>
    </article>
  </div>

    <div class="biochem__cta">
      <a class="btn btn-pro" routerLink="/categoria/chemistry">Explorar productos</a>
      <a class="btn btn-pro-outline" routerLink="/tienda" href="/tienda">Ver todas las categorías</a>
    </div>
  </div>
</section>

<!-- ===== Microscopios ===== -->
<section class="micros">
  <div class="container">
    <header class="micros__head">
         <img src="assets/images/astreo_text_white.png" width="150px">
      <h2 style="font-weight: 500;">
         <small style="color:#EE3221; ">Línea de microscopios</small>
           </h2>
      <p class="sub">
       Diseñada para una variedad de aplicaciones, <br>
        utilizando fuentes de luz LED para obtener imágenes de calidad.
      </p>

    </header>

    <div class="micros__grid">
      <article
        class="micros__card"
        *ngFor="let m of microsModels; trackBy: trackBySlug">
        <h3 class="micros__title">{{ m.title }}</h3>

        <div class="micros__main">
          <img
            [src]="imgPath(m.views[selectedViewIndex[m.slug] || 0])"
            [alt]="m.title + ' vista ' + ((selectedViewIndex[m.slug] || 0) + 1)"
            loading="lazy" />
        </div>

        <ul class="micros__thumbs">
          <li
            class="thumb"
            *ngFor="let v of (m.views | slice:0:4); let j = index">
            <button
              type="button"
              class="thumb__btn"
              [class.active]="(selectedViewIndex[m.slug] || 0) === j"
              (click)="selectView(m.slug, j)"
              [attr.aria-label]="'Vista ' + (j + 1)">
              <img
                [src]="imgPath(v)"
                [alt]="m.title + ' miniatura ' + (j + 1)"
                loading="lazy"
              />
            </button>
          </li>
        </ul>
      </article>
      
    </div>

    <!-- CTAs -->
    <div class="cats__cta">
      <a class="btn btn-pro" routerLink="/categoria/microscopes">Mas información</a>
      <a class="btn btn-glass-blue" routerLink="/cotizar">Solicitar cotización</a>
    </div>

  </div>
</section>

<!-- ===== Conectando resultados ===== -->
<section class="connect">
  <div class="container">
    <div class="connect__head">
      <div style="margin-bottom: 5px;">
        <img src="assets/logo/logo_text_alp_black.png" width="250px">
      </div>
      <br>
      
      <h2>Conectando resultados.</h2>
      <p class="sub">
        <strong>Alphanapsis®</strong> soluciones modernas
      </p>
    </div>

    <div class="connect__grid">
      <figure class="connect__media">
        <img src="assets/images/alphanapsisTablet.jpg" alt="App en tablet" loading="lazy">
      </figure>

      <div class="connect__content">
        <ul class="bullets" style="margin-top: -15px;">
          <img src="assets/logo/logo_text_alp_black.png" width="130px">  soluciones modernas para laboratorios y hospitales: arquitectura flexible, soporte 24/7, trazabilidad y fiabilidad. Interfaces para diversos analizadores, procesos automatizados con código de barras y 100% auditables. 
        </ul>

        <!-- Accordion: Funcionalidades LIS -->
<div class="accordion accordion-flush lis-accordion" id="lisAccordion">
  <div class="accordion-item" *ngFor="let it of lisItems; let i = index">
    <h2 class="accordion-header" [id]="'lisHeading'+i">
      <button
        class="accordion-button collapsed d-flex align-items-center gap-3"
        type="button"
        data-bs-toggle="collapse"
        [attr.data-bs-target]="'#lisCollapse'+i"
        aria-expanded="false"
        [attr.aria-controls]="'lisCollapse'+i"
      >
        <!-- Icono a la izquierda -->
        <i class="bi" [ngClass]="it.icon"></i>

        <!-- Título ocupa el espacio -->
        <span class="flex-grow-1 acc-title">{{ it.title }}</span>
        <!-- El chevron de Bootstrap queda a la derecha por defecto (::after) -->
      </button>
    </h2>
    <div
      [id]="'lisCollapse'+i"
      class="accordion-collapse collapse"
      role="region"
      [attr.aria-labelledby]="'lisHeading'+i"
      data-bs-parent="#lisAccordion"
    >
      <div class="accordion-body">
        <p class="mb-0">{{ it.description }}</p>
      </div>
    </div>
  </div>
</div>

        <br>
        <div class="cta"> 
          <a routerLink="/software/lis"  href="/software/lis" class="btn btn-pro">Conocer LIS</a>
          <a routerLink="/software" class="btn btn-pro-outline">Ver más soluciones</a>
        </div>
      </div>
    </div>
  </div>


  <br>
<div class="brands-row" aria-label="Marcas">
  <div class="brand-slot" *ngFor="let src of images; index as i">
    <div class="brand-card">
      <img [src]="src" [alt]="'Marca ' + (i + 1)" />
    </div>
  </div>
</div>



</section>